import { render, staticRenderFns } from "./AppLoginsMetrics.vue?vue&type=template&id=35481146&scoped=true&"
import script from "./AppLoginsMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppLoginsMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppLoginsMetrics.vue?vue&type=style&index=0&id=35481146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35481146",
  null
  
)

export default component.exports